import { UntypedFormGroup, UntypedFormControl, UntypedFormArray, Validators } from '@angular/forms';

import { PcgTableColumn } from '../../../../../table/pcg-table-column.interface';

// tslint:disable:quotemark
// tslint:disable:max-line-length
// tslint:disable:whitespace
export class EditUserVm {
	userId: number;
	fullName?: string;
	phoneNumber?: string;
	email?: string;
	userName?: string;
	isActive: boolean;
	permissionId?: number;
	permission?: string;
	isLockedOut: boolean;
	inactivityTimeout: boolean;
	smartyAddress?: any;
	address?: string;
	organizationId?: number;
	organizationString?: string;
	orgLoginType?: any;
	friendlyId?: string;
	siteIds?: number[];
	sites?: string[];
	dateMouAcknowledged?: string;
	permissionEntity?: any;
	isNewUser: boolean;
	loadBalanceTestString?: string;

	static get FormData() {
		return this.getFormData();
	}

	static getFormData(validators = {}) {
		return {
			'userId': new UntypedFormControl(0, [...(validators['userId'] ?? []), ...[Validators.required]]),
			'fullName': new UntypedFormControl(null, [...(validators['fullName'] ?? []), ...[Validators.required, Validators.minLength(2), Validators.maxLength(100), Validators.pattern("^[a-zA-Z ,.'-]+$")]]),
			'phoneNumber': new UntypedFormControl(null, [...(validators['phoneNumber'] ?? []), ...[Validators.pattern("(\\+\\d{1,3}\\s?)?((\\(\\d{3}\\)\\s?)|(\\d{3})(\\s|-?))(\\d{3}(\\s|-?))(\\d{4})(\\s?(([E|e]xt[:|.|]?)|x|X)(\\s?\\d+))?")]]),
			'email': new UntypedFormControl(null, [...(validators['email'] ?? []), ...[Validators.required, Validators.email]]),
			'userName': new UntypedFormControl(null, [...(validators['userName'] ?? []), ...[Validators.required, Validators.minLength(5), Validators.maxLength(50), Validators.pattern("^[A-Za-z0-9.@\\-_']+$")]]),
			'isActive': new UntypedFormControl(false, [...(validators['isActive'] ?? []), ...[]]),
			'permissionId': new UntypedFormControl(null, [...(validators['permissionId'] ?? []), ...[Validators.required]]),
			'permission': new UntypedFormControl(null, [...(validators['permission'] ?? []), ...[]]),
			'isLockedOut': new UntypedFormControl(false, [...(validators['isLockedOut'] ?? []), ...[]]),
			'inactivityTimeout': new UntypedFormControl(false, [...(validators['inactivityTimeout'] ?? []), ...[]]),
			'smartyAddress': new UntypedFormControl(null, [...(validators['smartyAddress'] ?? []), ...[]]),
			'address': new UntypedFormControl(null, [...(validators['address'] ?? []), ...[]]),
			'organizationId': new UntypedFormControl(null, [...(validators['organizationId'] ?? []), ...[]]),
			'organizationString': new UntypedFormControl(null, [...(validators['organizationString'] ?? []), ...[]]),
			'orgLoginType': new UntypedFormControl(null, [...(validators['orgLoginType'] ?? []), ...[]]),
			'friendlyId': new UntypedFormControl(null, [...(validators['friendlyId'] ?? []), ...[]]),
			'siteIds': new UntypedFormControl([], [...(validators['siteIds'] ?? []), ...[]]),
			'sites': new UntypedFormControl([], [...(validators['sites'] ?? []), ...[]]),
			'dateMouAcknowledged': new UntypedFormControl(null, [...(validators['dateMouAcknowledged'] ?? []), ...[]]),
			'permissionEntity': new UntypedFormControl(null, [...(validators['permissionEntity'] ?? []), ...[]]),
			'isNewUser': new UntypedFormControl(false, [...(validators['isNewUser'] ?? []), ...[]]),
			'loadBalanceTestString': new UntypedFormControl(null, [...(validators['loadBalanceTestString'] ?? []), ...[Validators.maxLength(100)]])
		};
	}

	static get Form() {
		return new UntypedFormGroup(this.FormData);
	}

	static GetModel(fg: UntypedFormGroup): EditUserVmFromFg {
		return new EditUserVmFromFg(fg);
	}
}

export class EditUserVmFromFg {
	constructor(public fg: UntypedFormGroup) { }


	get userId(): number {
		return this.fg.get('userId').value;
	}
	set userId(val) {
		this.fg.get('userId').setValue(val);
	}

	get fullName(): string {
		return this.fg.get('fullName').value;
	}
	set fullName(val) {
		this.fg.get('fullName').setValue(val);
	}

	get phoneNumber(): string {
		return this.fg.get('phoneNumber').value;
	}
	set phoneNumber(val) {
		this.fg.get('phoneNumber').setValue(val);
	}

	get email(): string {
		return this.fg.get('email').value;
	}
	set email(val) {
		this.fg.get('email').setValue(val);
	}

	get userName(): string {
		return this.fg.get('userName').value;
	}
	set userName(val) {
		this.fg.get('userName').setValue(val);
	}

	get isActive(): boolean {
		return this.fg.get('isActive').value;
	}
	set isActive(val) {
		this.fg.get('isActive').setValue(val);
	}

	get permissionId(): number {
		return this.fg.get('permissionId').value;
	}
	set permissionId(val) {
		this.fg.get('permissionId').setValue(val);
	}

	get permission(): string {
		return this.fg.get('permission').value;
	}
	set permission(val) {
		this.fg.get('permission').setValue(val);
	}

	get isLockedOut(): boolean {
		return this.fg.get('isLockedOut').value;
	}
	set isLockedOut(val) {
		this.fg.get('isLockedOut').setValue(val);
	}

	get inactivityTimeout(): boolean {
		return this.fg.get('inactivityTimeout').value;
	}
	set inactivityTimeout(val) {
		this.fg.get('inactivityTimeout').setValue(val);
	}

	get smartyAddress(): any {
		return this.fg.get('smartyAddress').value;
	}
	set smartyAddress(val) {
		this.fg.get('smartyAddress').setValue(val);
	}

	get address(): string {
		return this.fg.get('address').value;
	}
	set address(val) {
		this.fg.get('address').setValue(val);
	}

	get organizationId(): number {
		return this.fg.get('organizationId').value;
	}
	set organizationId(val) {
		this.fg.get('organizationId').setValue(val);
	}

	get organizationString(): string {
		return this.fg.get('organizationString').value;
	}
	set organizationString(val) {
		this.fg.get('organizationString').setValue(val);
	}

	get orgLoginType(): any {
		return this.fg.get('orgLoginType').value;
	}
	set orgLoginType(val) {
		this.fg.get('orgLoginType').setValue(val);
	}

	get friendlyId(): string {
		return this.fg.get('friendlyId').value;
	}
	set friendlyId(val) {
		this.fg.get('friendlyId').setValue(val);
	}

	get dateMouAcknowledged(): string {
		return this.fg.get('dateMouAcknowledged').value;
	}
	set dateMouAcknowledged(val) {
		this.fg.get('dateMouAcknowledged').setValue(val);
	}

	get permissionEntity(): any {
		return this.fg.get('permissionEntity').value;
	}
	set permissionEntity(val) {
		this.fg.get('permissionEntity').setValue(val);
	}

	get isNewUser(): boolean {
		return this.fg.get('isNewUser').value;
	}
	set isNewUser(val) {
		this.fg.get('isNewUser').setValue(val);
	}

	get loadBalanceTestString(): string {
		return this.fg.get('loadBalanceTestString').value;
	}
	set loadBalanceTestString(val) {
		this.fg.get('loadBalanceTestString').setValue(val);
	}
}
